import type { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Button } from "~/components/posties/button";
import { StyledOffsetContainer } from "~/components/posties/button/styles";
import type { ResponsiveVariants } from "~/lib/styles/responsive";
import { setResponsiveVariantStyles } from "~/lib/styles/responsive";

export const Container = styled.div``;

export const FeaturesWrapper = styled.div`
  display: flex;
  align-items: center;
`;

type ActionButtonProps = {
  $extraCss?: SerializedStyles;
  $responsiveVariants: ResponsiveVariants<"show" | "hidden">;
};

export const ActionButton = styled.div<ActionButtonProps>`
  cursor: pointer;

  ${props =>
    setResponsiveVariantStyles(props.$responsiveVariants, variant => {
      switch (variant) {
        case "show":
          return css`
            display: block;

            margin-inline-start: 8px;

            ${props.theme.breakpoints.up("tablet")} {
              margin-inline-start: 16px;
            }

            ${props.$extraCss}
          `;
        case "hidden":
          return css`
            display: none;
          `;
      }
    })}
`;

export const RedirectButtonContainer = styled.div`
  ${StyledOffsetContainer} {
    &::before {
      ${props => props.theme.breakpoints.up("tablet")} {
        inset-block-start: 4px;
        inset-inline-start: -3px;
      }
    }
  }
`;

export const StyledButton = styled(Button)`
  margin-block-end: 0;
  padding-block: 8px;
  padding-inline: 12px;

  font-size: 12px;
  line-height: 9px;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 8px;
    padding-inline: 16px;

    font-size: 14px;
    line-height: 18px;
  }
`;
